import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { getTrendingMagnetsURL } from "../../apis/magnets";
import { BrandContext } from "../../components/context/BrandContext";
import { TOAST_CONFIG } from "../../constants";
import { Brand } from "../../models";
import BrandDiscoverComponent from "./BrandDiscoverComponent";
import { get } from "../../utils/request";

function BrandDiscoverContainer() {
  const { getBrands } = useContext(BrandContext);
  const [brands, setBrands] = useState<Array<Brand>>([]);
  const [brandsLoading, setBrandsLoading] = useState<Boolean>(false);
  const [nextPageDataLink, setNextPageDataLink] = useState<string>(getTrendingMagnetsURL());
  const [trendingMagnetsPageNumber, setTrendingMagnetsPageNumber] = useState(0);

  const [trendingMagnets, setTrendingMagnets] = useState<{ [key: number]: PublicMagnet[] }>({});
  const [trendingMagnetsLoading, setTrendingMagnetsLoading] = useState(false);

  const callGetBrandsApi = async (tagName?: string) => {
    try {
      let response = null;
      setBrandsLoading(true);
      if (tagName === "All" || !tagName) response = await getBrands();
      else {
        response = await getBrands(tagName);
      }
      setBrands(response);
      setBrandsLoading(false);
    } catch {
      setBrandsLoading(false);
      setBrands([]);
    }
  };

  const getTrendingMagnets = async () => {
    if (nextPageDataLink) {
      setTrendingMagnetsLoading(true);
      get(nextPageDataLink, {
        processData: ({ data }) => {
          setTrendingMagnetsLoading(false);
          setTrendingMagnets({ ...trendingMagnets, [trendingMagnetsPageNumber]: data.results as PublicMagnet[] });
          setNextPageDataLink(data.next);
        },
        processError: () => {
          setTrendingMagnetsLoading(false);
          toast.error("Failed to fetch trending magnets.", TOAST_CONFIG);
        },
      });
    }
  };

  useEffect(() => {
    callGetBrandsApi();
  }, []);

  useEffect(() => {
    getTrendingMagnets();
  }, [trendingMagnetsPageNumber]);

  const onLastElementVisible = () => {
    setTrendingMagnetsPageNumber(trendingMagnetsPageNumber + 1);
  };

  // const { setWalkthroughRun, walkthroughData } = useWalkthroughContext();

  // useEffect(() => {
  //   if (walkthroughData.tourActive && brands.length) {
  //     setWalkthroughRun(true);
  //   }
  // }, [brands, walkthroughData.tourActive]);

  return (
    <>
      <Helmet>
        <title>Discover - MAGNETIQ</title>
      </Helmet>
      <BrandDiscoverComponent
        // onTagClick={callGetBrandsApi}
        // tags={tags}
        brands={brands}
        brandsLoading={brandsLoading}
        trendingMagnets={Object.values(trendingMagnets).flat()}
        onLastElementVisible={onLastElementVisible}
        trendingMagnetsLoading={trendingMagnetsLoading}
      />
    </>
  );
}

export default BrandDiscoverContainer;
